module.exports = __webpack_public_path__ + "static/media/seating_rows_distance.e4af9e7a.svg";